// export function tlpCheck(tlp) {
//   {
//     if (/^((13[0-9])|(14[5,7,9])|(166)|(19[8,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/.test(tlp)) {
//       return true;
//     }else{
//       return false;
//     }
//   }
// }
export function tlpCheck(tlp) {
  {
    if (String(tlp).length == 11) {
      return true;
    }else{
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/check.js